import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'

import SideMenu from './Sidebar'
import { Menus } from './UserRoleMenu'
import { PrevilageId, UserMenuAccess } from '../../../helper/HelperAuth'
import ActionGetAccessModule from '../../../store/action/AccessModule/Fetch'


class ItemMenu extends Component{
    componentDidMount(){
        this.props.actionGetAccessModule(PrevilageId);
    }

    render(){
        return( 
            
                    <SideMenu 
                    items={Menus} 
                    access={UserMenuAccess}  
                    ></SideMenu>
               
        );
    }
}


export default connect(
    (state) => {
        return {
            accessmodules: state.user.accessmodules,
        }
    },
    dispatch => bindActionCreators({
        actionGetAccessModule: ActionGetAccessModule,
    }, dispatch),
)(ItemMenu);